import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box } from '@mui/material';
import { AuthLayoutContainer } from 'components/Layouts/AuthLayout';
import { ProfileEdit } from 'components/ProfileEdit';
import { DetailPageLoadingCenter } from 'components/DetailPageLoadingCenter';
import { useAuthSession } from 'hooks/useAuthSession';
import { useAuthRedirect } from 'hooks/useAuthRedirect';
import { consumePostLoginReturnPath } from 'utils/postLoginReturnPath';
import { getOnboardingRouteRedirect } from 'utils/authNavigation';

export const Setup2FA = () => {
  const navigate = useNavigate();
  const session = useAuthSession();
  const { user: currentUser } = session;

  const resolveRedirect = useCallback((s) => getOnboardingRouteRedirect(s, 'setup2fa'), []);
  useAuthRedirect(resolveRedirect);

  const handleComplete = useCallback(() => {
    const next = consumePostLoginReturnPath();
    navigate(next || '/dashboard', { replace: true });
  }, [navigate]);

  if (!session.isAuthenticated || !currentUser) {
    return (
      <AuthLayoutContainer showGrayLogo>
        <DetailPageLoadingCenter label="Preparing two-factor setup..." />
      </AuthLayoutContainer>
    );
  }

  return (
    <AuthLayoutContainer showGrayLogo>
      <Box sx={{ maxWidth: 480, width: '100%', mx: 'auto' }}>
        <ProfileEdit
          variant="setup2fa"
          name={currentUser.name}
          phone_number={currentUser.phone}
          email={currentUser.email}
          image={currentUser.image}
          mfaMethod={currentUser.mfaMethod}
          jobTitle={currentUser.jobTitle}
          onComplete={handleComplete}
        />
      </Box>
    </AuthLayoutContainer>
  );
};
